/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'start': {
    width: 16,
    height: 16,
    viewBox: '0 0 24 24',
    data: '<g _fill="none" fill-rule="evenodd"><path pid="0" d="M1.75 12C1.75 6.347 6.347 1.75 12 1.75S22.25 6.347 22.25 12c0 5.569-4.462 10.114-10 10.247l-.25.003a10.4 10.4 0 0 1-.25-.003v-1.702H12c4.711 0 8.545-3.834 8.545-8.545S16.711 3.455 12 3.455 3.455 7.289 3.455 12 7.289 20.545 12 20.545h.25v1.702a10.4 10.4 0 0 1-.25.003h-.25c-5.538-.136-10-4.681-10-10.25zm8.89 4.518a1.747 1.747 0 0 1-1.31-.17 1.728 1.728 0 0 1-.87-1.505v-5.72a1.73 1.73 0 0 1 2.601-1.502l4.924 2.844c.144.08.275.178.388.292.192.193.294.326.376.512.124.273.177.473.177.712 0 .243-.053.445-.176.714a1.735 1.735 0 0 1-.37.518 1.729 1.729 0 0 1-.378.281l-4.914 2.836a1.758 1.758 0 0 1-.447.188zm4.545-4.52c.002-.016-.007-.025-.02-.039l-.018-.01-4.94-2.852a.032.032 0 0 0-.03.002.028.028 0 0 0-.013.024v5.72a.05.05 0 0 0 .005.017c.013.01.016.01.018.011a.065.065 0 0 0 .038-.011l4.723-2.726.211-.122.026-.015z" _fill="#000" fill-rule="nonzero"/></g>'
  }
})
